/**
 * add property to object
 *
 * @param {Object} obj     object
 * @param {String} name    name of property
 * @param {Function} onGet get's function
 * @param {Function} onSet set's function
 * @returns {void}
 */
export default function addProperty(obj, name, onGet, onSet) {

   // wrapper functions
   const
      oldValue = obj[name],
      getFn = () => onGet.apply(obj, [oldValue]),
      setFn = newValue => onSet.apply(obj, [newValue]);

   // Modern browsers, IE9+ (IE8 only works on DOM objects, not normal JS objects)
   if (Object.defineProperty) {

      Object.defineProperty(obj, name, {
         get: getFn,
         set: setFn
      });

      // Older Firefox
   } else if (obj.__defineGetter__) {

      obj.__defineGetter__(name, getFn);
      obj.__defineSetter__(name, setFn);

      // IE6-7
      // must be a real DOM object (to have attachEvent) and must be attached to document (for onpropertychange to fire)
   } else {

      const onPropertyChange = (event) => {

         if (event.propertyName === name) {

            // temporarily remove the event so it doesn't fire again and create a loop
            obj.detachEvent('onpropertychange', onPropertyChange);

            // get the changed value, run it through the set function
            setFn(obj[name]);

            // restore the get function
            obj[name] = getFn;
            obj[name].toString = () => getFn().toString();

            // restore the event
            obj.attachEvent('onpropertychange', onPropertyChange);
         }
      };

      try {
         obj[name] = getFn;
         obj[name].toString = () => getFn().toString();
      } catch (ex) {
         //
      }

      // add the property event change only once
      obj.attachEvent('onpropertychange', onPropertyChange);
   }
}
